import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { FIELD__base } from '../_base/FIELD__base';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';

export class FIELD__any extends FIELD__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_ANY;

  /*
   *
   */

  field_connectable__type(): ENUM__field_connectable_type {
    return ENUM__field_connectable_type.ANY;
  }

  field_connectable__value(graph: DTO_GRAPH__instance): string {
    return '';
  }

  /*
   *
   */

  is_field_is_compatible_to_sync_with(other: FIELD__base): boolean {
    return true;
  }
}
